import { Link, useLocation } from 'react-router';
import { LayoutDashboard, CreditCard, Receipt, Tag, TrendingUp, Home } from 'lucide-react';

const nav = [
  { label: 'Overview', href: '/finance', icon: LayoutDashboard },
  { label: 'Transactions', href: '/finance/transactions', icon: Receipt },
  { label: 'Coupons', href: '/finance/coupons', icon: Tag },
  { label: 'Stripe Events', href: '/finance/stripe', icon: CreditCard },
  { label: 'Revenue', href: '/finance/revenue', icon: TrendingUp },
];

export default function FinanceSidebar() {
  const { pathname } = useLocation();

  return (
    <>
      <div className="sidebar-logo">
        <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <Home size={16} style={{ color: 'var(--text-tertiary)' }} />
          <span style={{ color: '#2563eb', fontWeight: 700 }}>Finance</span>
          <span style={{ fontSize: '0.7rem', color: 'var(--text-tertiary)', fontWeight: 400 }}>admin</span>
        </Link>
      </div>
      <nav className="sidebar-nav">
        <div className="sidebar-section">
          <div className="sidebar-section-title">Billing</div>
          {nav.map(({ label, href, icon: Icon }) => (
            <Link key={href} to={href} className={`sidebar-link ${pathname === href || (href !== '/finance' && pathname.startsWith(href + '/')) ? 'active' : ''}`}>
              <Icon /> {label}
            </Link>
          ))}
        </div>
      </nav>
    </>
  );
}
